<template>
  <div class="login">
    <div class="top-nav has-text-centered-touch">
      <a v-if="emailHelp">
        <font-awesome-icon
          id="hideBrand"
          icon="envelope"
          size="2x"
          class="icon-support"
        />
        <div class="support-text">
          {{ emailHelp }}
        </div>
      </a>
      <br class="is-hidden-tablet">
      <a v-if="phoneHelp">
        <font-awesome-icon
          id="hideBrand"
          icon="phone"
          size="2x"
          class="icon-support"
        />
        <div class="support-text">
          {{ phoneHelp }}
        </div>
      </a>
    </div>
    <center-panel>
      <div class="webcom-authenticator">
        <img
          v-if="$store.state.logos.length"
          class="brand-logo image"
          :src="$store.state.logos[0]"
        >
        <img
          v-else
          src="../assets/dc-logo-web.com-black.png"
          class="web-logo image"
          alt="webdotcom"
        >
        <sign-in
          v-if="(authState === SIGNED_OUT)"
          :validation-runner="validationRunner"
          :validation-checks="[isValidUsername, isValidPassword]"
          @changeAuthState="changeAuthState"
          @displayError="displayError"
        />
        <reset-password
          v-else-if="authState === REQUIRE_NEW_PASSWORD"
          @changeAuthState="changeAuthState"
          @displayError="displayError"
        />
        <auto-reset-password
          v-else-if="authState === AUTO_RESET_PASSWORD"
          :username="autoResetPassword[1]"
          @changeAuthState="changeAuthState"
          @displayError="displayError"
        />
        <sign-up
          v-else-if="authState === SIGN_UP"
          :validation-runner="validationRunner"
          :validation-checks="[isValidUsername, isValidPassword, isValidEmail]"
          @changeAuthState="changeAuthState"
          @displayError="displayError"
        />
        <confirm-sign-up
          v-else-if="authState === CONFIRM_SIGN_UP"
          @changeAuthState="changeAuthState"
          @displayError="displayError"
        />
        <div
          v-if="error"
          class="error"
        >
          <p>{{ error }}</p>
        </div>
      </div>
    </center-panel>
  </div>
</template>

<script>
import CenterPanel from '@/components/Shared/CenterPanel'
import SignIn from '@/components/Authenticator/SignIn'
import ResetPassword from '@/components/Authenticator/ResetPassword'
import AutoResetPassword from '@/components/Authenticator/AutoResetPassword'
import SignUp from '@/components/Authenticator/SignUp'
import ConfirmSignUp from '@/components/Authenticator/ConfirmSignUp'
import { mapState, mapActions } from 'vuex'

import {
  SIGNED_OUT,
  REQUIRE_NEW_PASSWORD,
  AUTO_RESET_PASSWORD,
  SIGN_UP,
  CONFIRM_SIGN_UP
} from '@/components/Authenticator/auth-actions'
export default {

  name: 'WebcomAuthenticator',

  components: {
    SignIn,
    ResetPassword,
    AutoResetPassword,
    SignUp,
    ConfirmSignUp,
    CenterPanel
  },
  data () {
    return {
      SIGNED_OUT,
      REQUIRE_NEW_PASSWORD,
      AUTO_RESET_PASSWORD,
      SIGN_UP,
      CONFIRM_SIGN_UP,
      authState: SIGNED_OUT,
      error: ''
    }
  },
  computed: {
    ...mapState(['autoResetPassword']),
    phoneHelp () {
      if (this.$store.state.useLocalStyle) {
        return this.$t('phone_number.help')
      }
      return this.$store.getters.brandConfigValue('phone_number', 'help')
    },
    emailHelp () {
      if (this.$store.state.useLocalStyle) {
        return this.$t('email.help')
      }
      return this.$store.getters.brandConfigValue('email', 'help')
    }
  },
  watch: {
    authState () {
      this.error = ''
    },
    autoResetPassword ([status, user]) {
      if (status === true) {
        this.changeAuthState(this.AUTO_RESET_PASSWORD)
      }
    }
  },
  methods: {
    ...mapActions(['createAutoPasswordResetTuple']),
    displayError (error) {
      this.error = error
      this.createAutoPasswordResetTuple(null)
    },

    changeAuthState (newAuthState) {
      if (newAuthState !== this.AUTO_RESET_PASSWORD) {
        this.createAutoPasswordResetTuple(null)
      }
      this.authState = newAuthState
    },

    validationRunner (v, checks) {
      const [validationError] = checks
        .map(check => check(v))
        .filter(tuple => tuple[0] === false)

      if (v.$invalid) {
        this.displayError(validationError
          ? validationError[1]
          : this.$t('authenticator.validation.form'))
      }
    },

    isValidEmail ({ user }) {
      const { email } = user.attributes
      if (email.required === false) {
        return [false, this.$t('authenticator.validation.em_req')]
      }
      if (email.email === false) {
        return [false, this.$t('authenticator.validation.em_invalid')]
      }
      return [true]
    },

    isValidUsername ({ user }) {
      const { username } = user
      if (username.required === false) {
        return [false, this.$t('authenticator.validation.un_req')]
      }
      return [true]
    },

    isValidPassword ({ user }) {
      const { password } = user
      if (password.required === false) {
        return [false, this.$t('authenticator.validation.pw_req')]
      }
      if (password.minLength === false) {
        return [
          false,
          this.$t('authenticator.validation.pw_min', { min: password.$params.minLength.min })
        ]
      }
      return [true]
    }
  }
}
</script>
<style lang="scss">
@import '../../sass/_variables.scss';
.support-text {
  display: inline-block;
  margin-right: 20px;
  color: var(--base-grey-medium);
  font-size: 18px;
  height: 1em;
  font-weight: bold;
  vertical-align: 5px;
}
.icon-support {
  background: var(--primary-color);
  line-height: 40px;
  border-radius: 100%;
  margin: 0px 10px;
  color: white;
  height: 1em;
  text-align: center;
  margin-top: 10px;
  padding: 8px;
}
.top-nav {
  float: right;
}
@media only screen and (max-width: 812px) {
  .top-nav {
    float: none !important;
    margin-bottom: 25px;
  }
}
.webcom-authenticator {
  position: relative;
  padding: 35px 40px;
  text-align: left;
  color: var(--base-grey-medium);
  background-color: white;

  .web-logo {
    margin-left: auto;
    margin-right: auto;
    margin-bottom: 50px;
    margin-top: 20px;
    max-width: 180px;
  }

  .brand-logo {
    margin-left: auto;
    margin-right: auto;
    margin-bottom: 30px;
    margin-top: 5px;
    max-width: 140px;
  }

  input {
    padding: 25px;
    margin-bottom: 10px;
  }

  .help {
    font-size: 1.2rem;
    margin-top: 10px;
  }

  .login-header {
    padding-bottom: 25px;
  }

  .error {
    padding-top: 5px;
    color: red;
  }
}
</style>
